import React, { Component } from 'react';

// Component used for marketing campaigns, meant to be hidden when campaigns are not active
class CreditCardReductionBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldRenderBanner: false,
        };
    }
    componentDidMount() {
        const currentBannerTimeUTC = Date.now();
        // 06/18/2024 6:00AM ET
        const creditCardReductionStartTimeUTC = Date.UTC(2024, 5, 18, 10, 0, 0, 0);
        // 06/18/2024 11:59PM ET
        const creditCardReductionEndTimeUTC = Date.UTC(2024, 5, 19, 3, 59, 59, 0);
        if (currentBannerTimeUTC >= creditCardReductionStartTimeUTC && currentBannerTimeUTC <= creditCardReductionEndTimeUTC) {
            this.setState({
                shouldRenderBanner: true
            });
        }
    }
    render() {
        const { shouldRenderBanner } = this.state;
        return shouldRenderBanner && (
            <div className="credit-card-reduction-banner sprk-o-Stack sprk-o-Stack--center-column">
                <div className="credit-card-reduction-container sprk-o-Box">
                    <h2 className="sprk-u-Color--white sprk-u-mvm">Today only: Close your loan and get $100 e-gift card!</h2>
                    <h3 className="sprk-u-Color--white sprk-u-mbl"><span className="banner-bolded">Enjoy our summer fund-ing promotion by closing a personal loan before midnight and receiving a $100 e-gift card.* </span></h3>
                </div>
            </div>
        );
    }
}

export default CreditCardReductionBanner;
